<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100px">
				<el-form-item label="商城名称：" prop="shop_name">
					<el-input class="input" v-model="form.shop_name" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="公司主体：" prop="shop_subject">
					<el-input class="input" v-model="form.shop_subject" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="运营地址：" prop="shop_address">
                    <el-input class="input long-input" v-model="form.shop_address" placeholder="请输入详细地址" clearable></el-input>
				</el-form-item>
				<el-form-item label="经营负责：" prop="shop_header">
					<el-input class="input" v-model="form.shop_header" placeholder="请输入负责人姓名" clearable></el-input>
					<el-input class="input" v-model="form.shop_phone" placeholder="请输入负责人电话" clearable></el-input>
				</el-form-item>
				<el-form-item label="登陆账号：" prop="shop_account">
					<el-input class="input" v-model="form.shop_account" placeholder="请输入账号" clearable></el-input>
					<el-input class="input" v-model="form.shop_password" placeholder="请输入密码" clearable></el-input>
				</el-form-item>
                <!-- <el-form-item label="服务地址：" prop="shop_url">
                    <el-input class="input long-input" v-model="form.shop_url" placeholder="请输入http开头的服务器地址" clearable></el-input>
				</el-form-item> -->
				<el-form-item label="有效期限：" prop="shop_start_end">
					<el-date-picker class="picker" v-model="form.shop_start_end" 
                    type="datetimerange" 
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" 
                    placeholder="请选择时间范围" />
				</el-form-item>
				<el-form-item label="备注说明：" prop="shop_remark">
					<el-input class="input long-input" v-model="form.shop_remark" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		shopAdd,
		shopEdit,
		shopDetail
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
        props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '新增',
				form: {
                    shop_id: '',
					shop_name: '',
					shop_subject: '',
					shop_address: '',
					shop_header: '',
                    shop_phone: '',
                    shop_account: '',
                    shop_password: '',
                    // shop_url: '',
                    shop_start_end: [],
                    shop_start: '',
                    shop_end: '',
                    shop_remark: '',
				},
                rules: {
					shop_name: [
                        { required: true, message: '请输入商城名称', trigger: 'blur' },
                        { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ],
					shop_subject: [
                        { required: true, message: '请输入商城主体', trigger: 'blur' },
                        { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ],
					shop_address: [
                        { required: true, message: '请输入运营地址', trigger: 'blur' },
                        { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
                    ],
					shop_header: [{ required: true, message: '请设置负责人名称', trigger: 'blur' }],
					shop_phone: [
                        { required: true, message: '请设置负责人手机号', trigger: 'blur' },
                        { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                    ],
                    shop_account: [
                        { required: true, message: '请设置登录账号', trigger: 'blur' },
                        { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                    ],
                    shop_password: [
                        { required: true, message: '请设置登录密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                    // shop_url: [{ required: true, message: '请设置商城服务器地址', trigger: 'blur' }],
                    shop_start_end: [{ required: true, message: '请选择有效期限', trigger: 'blur' }],
                    shop_remark: [{ min: 1, max: 50, message: '长度在 1 到 30 个字符', trigger: 'blur' }],
				},
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
					padding: '0 0'
				}
			}
		},
		mounted() {
            if (this.type != -1) {
				//详情编辑
                this.title = '编辑';
				this.form.shop_id = this.type;
				this.getShopDetail();
			}
        },
		methods: {
            //获取供应商详情
			getShopDetail(){
				shopDetail({shop_id:this.form.shop_id}).then(res=>{
					if(res.code == 0){
                        res.data.shop_start_end = [res.data.shop_start, res.data.shop_end];
                        this.form = res.data;
					}
				}).catch(err=>{})
			},

            //提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
                        this.form.shop_start = this.form.shop_start_end[0];
                        this.form.shop_end = this.form.shop_start_end[1];

						if (this.type != -1) {
							//编辑
							shopEdit(this.form).then(res => {
								if (res.code == 0) {
                                    this.$message({ type: 'success', message: res.msg || '操作成功!' });
									this.$emit('close', 0)
								}else{
                                    this.$message({ type: 'error', message: res.msg || '操作失败!' });
                                }
							}).catch(err => {})
						} else {
							//新增
							shopAdd(this.form).then(res => {
								if (res.code == 0) {
                                    this.$message({ type: 'success', message: res.msg || '操作成功!' });
									this.$emit('close', 0)
								}else{
                                    this.$message({ type: 'error', message: res.msg || '操作失败!' });
                                }
							}).catch(err => {})
						}
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

    .long-input {
        width: 420px;
    }

	.select {
		width: 137px;
		margin-right: 20px;
	}
	
	.picker {
		width: 420px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>